<div class="m-input-search">
  <input
    #searchInput
    type="text"
    pInputText
    [(ngModel)]="value"
    (ngModelChange)="onValueChange($event)"
    (blur)="onBlur()"
    [placeholder]="placeholder"
    [disabled]="disabled" />
  @if (value?.length) {
    <span
      class="material-symbols-outlined bg-gray-000 text-blue-600 icon-small cursor-pointer"
      (click)="clearInput()"
      >close</span
    >
    <div class="divider"></div>
  }

  <span
    class="material-symbols-outlined bg-gray-000 text-blue-600 icon-small cursor-pointer"
    >search</span
  >
</div>
